import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideRecruit() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        {/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            インターンシップ
          </Typography>
          　デーリー東北新聞社は、２０２１卒の大学生と大学院生を対象とした「1ＤＡＹインターンシップ」を開催します。参加する学生を募集しています。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/internship" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>
        */}

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            採用情報
          </Typography>
          ２０２２年度採用募集は終了しました。
          {/*
          デーリー東北新聞社は２０２２年４月採用の社員を募集します<br />
          */}
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/recruit" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
            <br />
            <Box textAlign="left">
              問い合わせ先<br />
              株式会社デーリー東北新聞社　企画総務局総務部<br />
              TEL:0178-44-5111<br />
            </Box>
          </Box>
        </Box>

      </div>
    </div>
  );
}

export default GuideRecruit;
